import { useTranslation } from 'react-i18next';

const featureKeys = [
  { icon: 'ri-shield-check-line', titleKey: 'why_feature1_title', descKey: 'why_feature1_desc', color: 'from-emerald-50 to-emerald-100', iconBg: 'bg-emerald-500' },
  { icon: 'ri-translate-2', titleKey: 'why_feature2_title', descKey: 'why_feature2_desc', color: 'from-sky-50 to-sky-100', iconBg: 'bg-sky-500' },
  { icon: 'ri-search-eye-line', titleKey: 'why_feature3_title', descKey: 'why_feature3_desc', color: 'from-rose-50 to-rose-100', iconBg: 'bg-rose-500' },
  { icon: 'ri-phone-line', titleKey: 'why_feature4_title', descKey: 'why_feature4_desc', color: 'from-amber-50 to-amber-100', iconBg: 'bg-amber-500' },
  { icon: 'ri-money-dollar-circle-line', titleKey: 'why_feature5_title', descKey: 'why_feature5_desc', color: 'from-teal-50 to-teal-100', iconBg: 'bg-teal-500' },
  { icon: 'ri-map-pin-2-line', titleKey: 'why_feature6_title', descKey: 'why_feature6_desc', color: 'from-pink-50 to-pink-100', iconBg: 'bg-pink-500' },
];

const statKeys = [
  { value: '50+', labelKey: 'why_stat_institutions', icon: 'ri-hospital-line' },
  { value: '20+', labelKey: 'why_stat_treatments', icon: 'ri-stethoscope-line' },
  { value: '15+', labelKey: 'why_stat_countries', icon: 'ri-global-line' },
  { value: '%98', labelKey: 'why_stat_satisfaction', icon: 'ri-star-line' },
];

export default function WhyUsSection() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-20">
          {statKeys.map((stat) => (
            <div key={stat.labelKey} className="flex flex-col items-center text-center p-6 bg-white rounded-2xl border border-gray-100">
              <div className="w-10 h-10 flex items-center justify-center bg-rose-50 rounded-xl mb-3">
                <i className={`${stat.icon} text-rose-500 text-lg`}></i>
              </div>
              <p className="text-2xl font-bold text-gray-900 font-['Outfit']">{stat.value}</p>
              <p className="text-xs text-gray-500 mt-1">{t(stat.labelKey)}</p>
            </div>
          ))}
        </div>

        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-['Outfit']">
            {t('why_title')} <span className="text-rose-500">{t('why_title_highlight')}</span>
          </h2>
          <p className="text-base text-gray-500 max-w-xl mx-auto">
            {t('why_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featureKeys.map((feature, index) => (
            <div
              key={index}
              className={`group p-6 rounded-2xl bg-gradient-to-br ${feature.color} hover:-translate-y-1 transition-all duration-300 border border-white`}
            >
              <div className={`w-12 h-12 flex items-center justify-center ${feature.iconBg} rounded-xl shadow-lg mb-5`}>
                <i className={`${feature.icon} text-white text-xl`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2 font-['Outfit']">{t(feature.titleKey)}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{t(feature.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
